import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldConfig } from '../field-interface';
import { UntypedFormGroup } from '@angular/forms';
import { Constant } from 'src/app/constant/constant';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { downloads } from '../../utils/calsoft-validators';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-file-upload-g',
  templateUrl: './file-upload-g.component.html',
  styleUrls: ['./file-upload-g.component.scss']
})
export class FileUploadGComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  field: FieldConfig['eavAttribute'];
  group: UntypedFormGroup;
  text: string;
  public serverPath = environment.commonImageApi + 'gallery/';
  value: any;
  constructor(
    private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {

    console.log(this.field);

    console.log(this.group);
    
    this.text = "Save"
    this.value= this.group.value[this.field.attributeCode];

    console.log(this.value);
  }
  imageVisible: boolean = true;
  imageDelete: boolean;
  imagesToRemoved: any = [];
 
  deleteImage(i) {
    this.imageVisible = false;
    this.imageDelete = true;
    let smallImage = "/gallery/" + this.group.value[this.field.attributeCode];
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save"
          this.imageVisible = false;
          this.imageDelete = false;
          
        }
        else {
          this.imageVisible = true;
          this.imageDelete = false;
          this.group.value[this.field.attributeCode]='';
          this.group.patchValue(this.group.value)
          this.text = "Save"
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.imageVisible = true;
      });

  }

  getResult(event) {
    this.imageVisible = true;

    this.group.value[this.field.attributeCode]=event.productEntityMediaGallery[0].fileName
    this.group.patchValue(this.group.value)
    this.value= this.group.value[this.field.attributeCode];
  }
  cancelUpload() {
    this.imageVisible = true;
  }

  logo() {
    this.imageVisible = false;
  }

  download() {
    let smallImage = "/gallery/" + this.group.value[this.field.attributeCode];
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloads(data);
      })
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
